import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getTechnologiesPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/technologie",
		[Locale.en]: "/technologies",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
